import React, { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';

const EditCustomerModal = ({ isOpen, onClose, onSave, customer }) => {
    // Inicializa o estado do formulário com todos os campos, incluindo birthDate
    const [formState, setFormState] = useState({
        name: '',
        phone: '',
        email: '',
        address: '',
        birthDate: ''
    });

    // Quando o modal abre ou o cliente a ser editado muda, atualiza o formulário
    useEffect(() => {
        if (customer && isOpen) {
            // Formata a data de nascimento para o formato YYYY-MM-DD que o input[type=date] espera
            const birthDate = customer.birthDate 
                ? new Date(customer.birthDate).toISOString().split('T')[0] 
                : '';

            setFormState({
                name: customer.name || '',
                phone: customer.phone || '',
                email: customer.email || '',
                address: customer.address || '',
                birthDate: birthDate
            });
        }
    }, [customer, isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Validação atualizada para todos os campos obrigatórios
        if (!formState.name || !formState.phone || !formState.email || !formState.birthDate) {
            alert('Por favor, preencha todos os campos obrigatórios: Nome, Telefone, Email e Data de Nascimento.');
            return;
        }
        try {
            // Prepara os dados para salvar, convertendo a data de volta para um objeto Date
            const updatedData = {
                ...formState,
                birthDate: formState.birthDate ? new Date(`${formState.birthDate}T00:00:00`) : null
            };
            await onSave(customer.id, updatedData);
            onClose(); // Fecha o modal após salvar com sucesso
        } catch (error) {
            console.error("Erro ao atualizar cliente:", error);
            alert("Ocorreu um erro ao atualizar o cliente.");
        }
    };

    return (
        <div className="modal-overlay">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-lg m-4 sm:m-8 max-h-[90vh] overflow-y-auto">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Editar Cliente</h2>
                {customer && (
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label htmlFor="edit-name" className="form-label">Nome Completo</label>
                            <input
                                id="edit-name"
                                name="name"
                                value={formState.name}
                                onChange={handleChange}
                                type="text"
                                placeholder="Ex: Maria da Silva"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                required
                            />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label htmlFor="edit-phone" className="form-label">Telefone</label>
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={formState.phone}
                                    onChange={handleChange}
                                >
                                    {(inputProps) => (
                                        <input
                                            {...inputProps}
                                            id="edit-phone"
                                            name="phone"
                                            type="tel"
                                            placeholder="(XX) XXXXX-XXXX"
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                            required
                                        />
                                    )}
                                </InputMask>
                            </div>
                            <div>
                                <label htmlFor="edit-birthDate" className="form-label">Data de Nascimento</label>
                                <input
                                    id="edit-birthDate"
                                    name="birthDate"
                                    value={formState.birthDate}
                                    onChange={handleChange}
                                    type="date"
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700"
                                    required
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="edit-email" className="form-label">Email</label>
                            <input
                                id="edit-email"
                                name="email"
                                value={formState.email}
                                onChange={handleChange}
                                type="email"
                                placeholder="exemplo@email.com"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="edit-address" className="form-label">Endereço (Opcional)</label>
                            <input
                                id="edit-address"
                                name="address"
                                value={formState.address}
                                onChange={handleChange}
                                type="text"
                                placeholder="Rua, Número, Bairro, Cidade"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                            />
                        </div>
                        <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 pt-4">
                            <button
                                type="button"
                                onClick={onClose}
                                className="py-2 px-6 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 w-full sm:w-auto"
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="custom-button py-2 px-6 font-semibold rounded-lg w-full sm:w-auto"
                            >
                                Salvar Alterações
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default EditCustomerModal;
